import { ClientRole } from "./client-role.model";
import { Serializer } from "../resource/serializer.interface";

/**
 * Maps the snake_case API shape to the camelCase ClientRole model. The API
 * contract is defined in the RBAC design spec; the backend is pending.
 */
export class ClientRoleSerializer implements Serializer {
  fromJson(json: any): ClientRole {
    const role = new ClientRole();
    role.id = json.id;
    role.key = json.key;
    role.name = json.name;
    role.description = json.description;
    role.permissions = json.permissions || [];
    role.isSystem = json.is_system === true;
    role.color = typeof json.color === "number" ? json.color : 0;

    return role;
  }

  toJson(role: ClientRole): any {
    return {
      id: role.id,
      key: role.key,
      name: role.name,
      description: role.description,
      permissions: role.permissions,
      is_system: role.isSystem,
      color: role.color,
    };
  }
}
